module.exports = "p {\n  color: #3a3a3a;\n  font-size: 13px;\n  font-family: Montserrat-Regular;\n  margin-bottom: 0px;\n}\n.support-subheading {\n  font-size: 15px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  font-family: Montserrat-Bold;\n}\n@media (min-width: 768px) {\n  .list-item-wrapper-white {\n    height: 215px;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/support/support.component.css
// module id = ./src/app/feature/main/roles-shared/components/support/support.component.css
// module chunks = main